// Бонусы сотрудников
import { create } from 'zustand';
import { getPenaltyBonuses, getPenaltyBonusById, addPenaltyBonus, updatePenaltyBonus } from 'services';

export const usePenaltyBonusStore = create((set) => ({
	penaltyBonusList: [],
	penaltyBonusById: {},
	loadingBonus: false,
	getPenaltyBonuses: async (data) => {
		set({ loadingBonus: true });
		const penaltyBonusList = await getPenaltyBonuses(data);
		set({ penaltyBonusList, loadingBonus: false });
	},
	addPenaltyBonus: async (data) => {
		await addPenaltyBonus(data);
	},
	getPenaltyBonusById: async (id) => {
		const penaltyBonusById = await getPenaltyBonusById(id);
		set({ penaltyBonusById });
	},
	updatePenaltyBonus: async ({ id, data }) => {
		await updatePenaltyBonus({ id, data });
	},
}))